import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { subscribeToList, SubscribeToListApiParameter } from "@TKCCP/Services/SubscribeEmailService";

export interface SubscribeParameter {
    email: string;
    onSuccess?: () => void;
    onError?: () => void;
}

type HandlerType = ApiHandlerDiscreteParameter<SubscribeParameter, SubscribeToListApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { emailAddress: props.parameter.email };
};

export const SendDataToApi: HandlerType = async props => {
    const result = await subscribeToList(props.apiParameter);
    // if (!result.successful) {
    //     props.parameter.onError?.();
    // } else {
    //     props.parameter.onSuccess?.();
    // }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const subscribeHandler = createHandlerChainRunner(chain, "SubscribeHandler");
export default subscribeHandler;
